import React from 'react';
import GooglePlayButton from './GooglePlayButton';
import AppStoreButton from './AppStoreButton';
import '../../styles/components/HomeSection/GetApp.css';

const GetApp: React.FC = () => {
  return (
    <section id="get-app" className="get-app-section">
        <h2 className="get-app-title">Ready to End Parking Jams?</h2>
        <p className="get-app-description">
          Join thousands of drivers who have already transformed their parking experience with RushHour.
        </p>
        <div className="get-app-buttons">
          <GooglePlayButton />
          <AppStoreButton />
        </div>
    </section>
  );
};

export default GetApp;
